import { HttpClient } from '../httpClient';
import ProgramsResponse from '../responses/programsResponse';
import ProgramResponse from '../responses/programResponse';
import { BaseResponse, DataResponse } from '../responses/baseResponse';
import ProgramRequest from '../requests/programRequest';
import Program from '../models/program';
import { selectOption } from '../../types/selectOption';
import TargetProgramsResponse from '../responses/targetProgramsResponse';

const httpClient = new HttpClient();

export const getProgramsByDistrict = async (districtId: number, divisionId?: number) => {
  let url = '/v1/programs';
  if (districtId > 0)
    url += `?districtId=${districtId}`;

  if (divisionId !== undefined && divisionId > 0) {
    let preSymbol = url.includes('?') ? '&' : '?';
    url += `${preSymbol}divisionId=${divisionId}`;
  }

  return httpClient.get<ProgramsResponse>({
    url: url,
    requiresToken: true,
  });
};

export const getPrograms = async () => {
  return httpClient.get<ProgramsResponse>({
    url: `/v1/programs?districtId=`,
    requiresToken: true,
  });
};

export const getProgram = async (programId: number) => {
  return httpClient.get<ProgramResponse>({
    url: `/v1/programs/${programId}`,
    requiresToken: true,
  });
};

export const createProgram = async (programrequest: ProgramRequest) => {
  return httpClient.post<DataResponse<Program>>({
    url: '/v1/admin/programs',
    payload: programrequest,
    requiresToken: true,
  });
};

export const getProgramOptions = async () => {
  return httpClient.get<DataResponse<selectOption[]>>({
    url: `/v1/programs/Options`,
    requiresToken: true,
  });
};

export const updateProgram = async (
  programId: number,
  programrequest: ProgramRequest
) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/admin/programs/${programId}`,
    payload: programrequest,
    requiresToken: true,
  });
};

export const deleteProgram = async (programId: number) => {
  return httpClient.delete<BaseResponse>({
    url: `/v1/admin/programs/${programId}`,
    requiresToken: true,
  });
};

export const getTargetPrograms = async (startDate: Date,endDate: Date,userId: number, disciplineId: number) => {
  return httpClient.get<TargetProgramsResponse>({
    url: `/v1/Programs/TargetProgramList?startDate=${startDate.toDateString()}&endDate=${endDate.toDateString()}&userId=${userId}&currentDisciplineId=${disciplineId}`,
    requiresToken: true,
  });
};